export default "__VITE_ASSET__DB932jBb__"